import { BigNumber } from '@ethersproject/bignumber';
import { parseUnits } from '@ethersproject/units';
import { useMemo } from 'react';

const getNormalizedAmount = (amount: string, decimals: number): BigNumber | null => {
  try {
    if (!amount || isNaN(parseFloat(amount))) return null;

    const amountBN = parseUnits(amount, decimals);

    return amountBN.isZero() ? null : (amountBN as BigNumber);
  } catch (err) {
    console.error('[get normalized amount]', err);
    return null;
  }
};

export const useNormalizedTokenInputAmount = (amount: string, decimals: number) =>
  useMemo(() => getNormalizedAmount(amount, decimals), [amount, decimals]);
